import { generateUzPaymentQr } from './qrGenerator';
import type { UzPayConfig, PaymentQrResult } from './types';

export class UzPayPlugin {
  private config: UzPayConfig;

  constructor(config: UzPayConfig) {
    this.config = config;
  }

  public async createPayment(amountUz: number, orderId: string): Promise<PaymentQrResult> {
    return generateUzPaymentQr(this.config, amountUz, orderId);
  }
}

export { generateUzPaymentQr };
export type { UzPayConfig, PaymentQrResult, UzPaymentProvider } from './types';
